// extracted by mini-css-extract-plugin
module.exports = {"content":"switcher_content__2Mx8B","switch":"switcher_switch__1e0ZE"};